module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAYAAADgKtSgAAAABGdBTUEAALGPC/xhBQAAAAlwSFlzAAALEgAACxIB0t1+/AAAAAd0SU1FB90CHAQGOpUkyP4AAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAGHRFWHRTb2Z0d2FyZQBwYWludC5uZXQgNC4wLjOM5pdQAAAApklEQVRIS9XVMQ6DMBAEQPv/HRJNHpKCP6ROzQvyBIfFLBzOEWxxV7DSSkjgWckNoS0xLQ/WiWn8vCfcZeCeOECJmw7E1D36GX++Bks8wxI3HHDB890SLvFtoGnkFz3CK0f4UkdRwKw2gEpnheXBmmowy292A6x2AK2BpbPAZf6PsLwuPJ+AWo5HLqBl9IGLKOOKI/sBQxhxxZE84AAj9/3NIS1wCF/ke82oIdBIRgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./assets/icons/prayer-icon.png
// module id = 498
// module chunks = 0